class DrawerCartA11y extends HTMLElement {
  constructor() {
    super();
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.cartIcon = document.querySelector('.open-cart-modal');
    this.previousFocus = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.addEventListener('keydown', this.handleKeydown.bind(this));
    
    // Use MutationObserver to detect when the class 'show-cart-modal' is added/removed
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const hasOpenClass = this.classList.contains('show-cart-modal');
          if (hasOpenClass && !this.isOpen) {
            this.open();
          } else if (!hasOpenClass && this.isOpen) {
            this.close();
          }
        }
      });
    });
    
    this.observer.observe(this, { attributes: true });
  }

  open() {
    this.isOpen = true;
    this.previousFocus = document.activeElement;
    
    // Set focus to the first focusable element inside the drawer
    setTimeout(() => {
      const firstFocusable = this.querySelector(this.focusableElements);
      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        this.focus();
      }
    }, 100); // Allow time for CSS transition
  }

  close() {
    this.isOpen = false;
    document.body.style.overflow = '';
    
    // Restore focus to the element that triggered the cart opening
    if (this.previousFocus) {
      this.previousFocus.focus();
    } else if (this.cartIcon) {
      this.cartIcon.focus();
    }
  }

  handleKeydown(e) {
    if (!this.isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.isOpen = false;
      this.classList.remove('show-cart-modal');
      document.body.style.overflow = '';
      if (this.previousFocus) {
        this.previousFocus.focus();
      } else if (this.cartIcon) {
        this.cartIcon.focus();
      }
      return;
    }

    if (e.key === 'Tab') {
      const nodes = this.querySelectorAll(this.focusableElements);
      // Filter out hidden or disabled elements
      const focusableNodes = Array.from(nodes).filter(node => 
        !node.disabled && 
        node.offsetParent !== null && 
        window.getComputedStyle(node).visibility !== 'hidden'
      );
      
      if (focusableNodes.length === 0) return;

      const firstNode = focusableNodes[0];
      const lastNode = focusableNodes[focusableNodes.length - 1];

      // Trap focus
      if (e.shiftKey) {
        if (document.activeElement === firstNode) {
          lastNode.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastNode) {
          firstNode.focus();
          e.preventDefault();
        }
      }
    }
  }
}

// Ensure the custom element isn't already defined before defining
if (!customElements.get('drawer-cart')) {
  customElements.define('drawer-cart', DrawerCartA11y);
}
